/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller.js                                                                   */
/**********************************************************************************************************************/
/* Controller */
HafasWebapp.prototype.Controller = {
  /**
   * @class this.Controller.App
   */
  App: {
    /**
     * Shows the cookie settings overlay
     * @param {object|undefined} opts If undefined, the menu is toggled
     * @param {boolean} opts.toggleFlyout If true, the menu is toggled
     */
    showCookieSettings: function(opts){
      if (opts === undefined || opts.toggleFlyout === true) {
        Hafas.ps.pub('/GUI/FlyIn/toggle', [{keepFocus: true}]);
      }

      if (Hafas.Modules.IFrameApi && Hafas.Modules.IFrameApi.externalCookieManagerActive === true) {
        // ExternalCookieManager enabled in HafasIframe/iframe api, notify the parent page to show the cookie banner
        Hafas.Modules.IFrameApi.sendShowCookieSettingsCallback();
        return;
      }

      Hafas.Util.gui.setVisibility(Hafas('#HFS_CookieHintBg',false),true);
      Hafas.Util.gui.dialog.open(Hafas('#HFS_CookieHint',false));
    },
    /**
     * Accepts the cookie categories by checkbox status, ExternalCookieManager choice or all
     * @param {{type: "all"}|{type: "selected"}|{functional:boolean, performance:boolean, marketing: boolean}} data Cookie acceptance for all, the selected checkboxes or the given categories
     * @param {boolean} externalCookieFlag True, if the cookie acceptance was sent by the externalCookieManager. In this case data will hold the cookie categories
     */
    acceptCookieSettings: function(data, externalCookieFlag) {
      data = data || {};
      externalCookieFlag = !!externalCookieFlag;
      var cookieSettingsCheckboxes = Hafas('input[data-cookie-content]', true);
      var cookieCategoryCount = cookieSettingsCheckboxes.length;
      var cookieCategories = Hafas.Config.Cookies.types.map(cat => cat.id); // Get the configured cookie categories
      var cookieSettingsData = {};
      var storage = Hafas.Core.newType("hafasStorage");
      var _application = '';
      if (typeof Hafas.Config.CustomerObj != 'undefined' && Hafas.Config.CustomerObj !== null) {
        _application = Hafas.Config.Storage.id + '_' + Hafas.Config.CustomerObj.name
      } else {
        _application = Hafas.Config.Storage.id;
      }

      if (externalCookieFlag === true) {
        // Cookies were given through iframe api, therefore we have to use the possible cookie categories from the webapp
        cookieCategoryCount = cookieCategories.length;
      }

      // Check for each cookie settings checkbox
      for (var i = 0; i < cookieCategoryCount; i++) {
        var tmpChbox;
        var type;

        if (externalCookieFlag === true) {
          // Check cookie acceptance in data given by external cookie banner, cookieSettings from storage, configured default or false
          var cookieSelected = false;
          if (data[cookieCategories[i]] !== undefined) {
            cookieSelected = data[cookieCategories[i]];
          } else if (Hafas.Config.CookieSettings[cookieCategories[i]] !== undefined) {
            cookieSelected = Hafas.Config.CookieSettings[cookieCategories[i]];
          } else if (Hafas.Config.Cookies.types.find(cat => cat.id === cookieCategories[i])?.checked !== undefined) {
            cookieSelected = Hafas.Config.Cookies.types.find(cat => cat.id === cookieCategories[i])?.checked;
          }
          tmpChbox = {checked: cookieSelected}; // Not a real checkbox, however only checked attribute is used, so we can fake it
          type = cookieCategories[i];
        } else {
          tmpChbox = cookieSettingsCheckboxes[i];
          type = tmpChbox.getAttribute("data-cookie-content");
        }

        if (data.type === 'all' || tmpChbox.checked) {
          // Accept all button was used, checkbox is checked or current cookie category was accepted via iframe api
          cookieSettingsData[type] = true;
          if (type === 'performance' && !Hafas.Core.trackerInitialized) {
            // Tracking
            Hafas.ps.pub('/twork/tracking/enable');
          }
          if (type === 'functional') {
            this.Controller.Favorites.instance.setEnabled(true);
            Hafas.Modules.Suggest.enableSuggestStorage();
          }
        } else {
          // Checkbox is not selected, disable specific features and remove saved data
          if (type === 'performance') {
            // Tracking
            Hafas.ps.pub('/twork/tracking/disable');
          } else if (type === 'functional') {
            Hafas.Modules.Suggest.disableSuggestStorage();
            this.Controller.Favorites.instance.setEnabled(false);
            this.Controller.Favorites.instance.resetAll();
            this.Controller.Favorites.instance.checkDataConsistency();
            storage.remove('hfsFavorites_' + _application);
            storage.remove('hfsColorScheme_' + Hafas.Config.Storage.id);
            storage.remove(Hafas.Config.Storage.id + '_SqOptions');
            storage.remove('elevationLevelHint_' + Hafas.Config.Storage.id);
            storage.remove('alarmUser_' + Hafas.Config.Storage.id);
            storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);
            storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
            storage.remove('LinesNews_' + Hafas.Config.Storage.id);

            // Special storage ID for hfsOptions
            var optionStorageId = '';
            if (Hafas.Config.CustomerObj !== undefined && Hafas.Config.CustomerObj !== null) {
              optionStorageId = Hafas.Config.Storage.id + '_' + Hafas.Config.CustomerObj.name
            } else {
              optionStorageId = Hafas.Config.Storage.id;
            }
            storage.remove('hfsOptions_TP_' + optionStorageId);
            storage.remove('hfsOptions_SQ_' + optionStorageId);
            storage.remove('hfsOptions_HimSearch_' + optionStorageId);
          }
          cookieSettingsData[type] = false;
        }
      }
      var storage = Hafas.Core.newType("hafasStorage");
      storage.set(Hafas.Config.Storage.id+ '_cookieSettings', JSON.stringify(cookieSettingsData));
      Hafas.Config.CookieSettings = cookieSettingsData;
      Hafas.ps.pub('/favorites/update');

      var closeTimeout = 0;
      if(data.type === 'all') {
        closeTimeout = 500;
        for(var k in cookieSettingsData) {
          if (Hafas('#HFS_CookieOption' + k, false)) {
            Hafas('#HFS_CookieOption' + k, false).checked = true;
          }
        }
        // iterate initial config params to check if additional cookie hint is available and needs to be toggled
        for (var k = 0; k < Hafas.Config.Cookies.types.length; k++) {
          if (Hafas.Config.Cookies.types[k].hasAdditionalHint !== undefined) {
            Hafas.ps.pub('/app/toggleCookieFeaturesHint',[{cookieType: Hafas.Config.Cookies.types[k].id}]);
          }
        }
      }
      window.setTimeout(function() {
        Hafas.Util.gui.setVisibility(Hafas('#HFS_CookieHintBg',false), false);
        Hafas.Util.gui.dialog.close(Hafas('#HFS_CookieHint',false));
      },closeTimeout);
    },
    /**
     * main function to switch between different app contexts
     *
     * @method switchContext
     * @param {Object} [data] - options for switching the context
     * @param {string} [data.context] - sets the context to switch to (e.g. TP, SQ, HimSearch, etc.)
     * @param {string} [data.method] - sets the method to call in that context, fallback is the "index"-function
     * @param {Object} [data.params] - passes an optional parameter object to the function that is called (being defined in data.method)
     * @param {boolean} [data.dontLeaveContext] - if "true" is passed, the current context won't be left, this can be used when a new context opens in a popup
     * @returns void
     */
    switchContext: function (data) {
      // e.g. for DOM or js-cleanup
      Hafas.ps.pub('/app/beforeSwitchContext', [data]);

      //close flyout
      Hafas.ps.pub('/map/closeToolbox', [{}]);

      // Fire event if the switchContext is called, but the WebApp is already in that context
      if(data.context == this.appContext) {
        Hafas.ps.pub('/app/switchContextNoChange', [data]);
      }

      // data kann leer sein, wenn kein applicationcontext ueber History gesetzt ist.
      // wenn das der Fall ist wird der Startcontext genommen
      if (!data) {
        data = {};
        data.context = Hafas.Config.startingAppContext;
        data.method = 'index';
      }

      data.params = data.params || {};

      if (this.layoutClass != 'small') {
        Hafas.ps.pub('/GUI/map/resetDimension');
      }
      if (this.layoutClass == 'small') {
        Hafas.ps.pub('/GUI/tabs/switch', [{trigger: null, ev: null, target: null}]);
      }

      var overview = Hafas('#' + this.resultOverviewContainer);
      var detail = Hafas('#' + this.resultDetailContainer);

      // Fire event for leaving context
      if (data.context != this.appContext && !data.dontLeaveContext) {
        Hafas.ps.pub('/GUI/leaveContext/');
        Hafas.ps.pub('/GUI/leaveContext/' + this.appContext);
        Hafas.ps.pub('/app/contextChanged',[data.context]);
        Hafas.ps.pub('/app/contextChanged/' + data.context,[]);
      }

      // change this.appContext
      this.prevContext = this.appContext;
      this.appContext = data.context;

      // Prueft ob ein Context in der TabNativagion vorhanden ist
      function _hasMainTab(appContext) {
        for (var i = 0; i < Hafas.Config.tabNavigation.length; i++) {
          if (Hafas.Config.tabNavigation[i].controller == appContext)
            return true;
        }
        return false;
      }

      // remove active class from all navigation tabs
      if (Hafas.Config.Switches.useTabNavigationDesktop || Hafas.Config.Switches.useTabNavigationMobile) {
        var tabNavList = Hafas('[data-tabnavitem]', true);
        var collectionNavItems = Hafas('[data-navitem]', true);
        if (collectionNavItems) {
          for (var item = 0; item < collectionNavItems.length; item++) {
            // Accessibity: Tabs in tablists should get aria-selected otherwise in FlyInMenu aria-current.
            if (tabNavList.includes(collectionNavItems[item])) {
              collectionNavItems[item].setAttribute("aria-selected", false);
              if (collectionNavItems[item].getAttribute('data-navitem') === this.appContext) {
                collectionNavItems[item].setAttribute("aria-selected", true);
              }
            } else {
              collectionNavItems[item].removeAttribute("aria-current");
              if (collectionNavItems[item].getAttribute('data-navitem') === this.appContext) {
                collectionNavItems[item].setAttribute("aria-current", true);
              }
            }
          }
        }
        // Accessiblity: Keyboard navigation for HFS_TabNavigation - HDSWAPP-2654
        var formWrapperForRolePanel = Hafas('#HFS_DocumentFormWrapper');
        // in case a menu item is active that is not in the tab list, there should be one navitem tabbable
        var hasActiveItem = false;
        tabNavList.forEach(function changeNavItems(item) {
          item.onkeydown = function (evt) {

            var key = Hafas.Util.gui.getKeyName(evt);

            var currentItem = evt.currentTarget || this;
            var newItem;

            switch (key) {
              case 'ArrowLeft':
                newItem = currentItem.previousElementSibling;
                break;
              case 'ArrowRight':
                newItem = currentItem.nextElementSibling;
                break;
              default:
                newItem = null;
                break;
            }
            if (newItem) {
              currentItem.setAttribute("tabindex", '-1');
              newItem.setAttribute("tabindex", '0');
              newItem.focus();
            }
          };
          item.setAttribute("tabindex", '-1');
          if (item.getAttribute('data-navitem') === this.appContext) {
            hasActiveItem = true;
            item.setAttribute("tabindex", '0');
            formWrapperForRolePanel.setAttribute("tabindex", '0');
            formWrapperForRolePanel.setAttribute("role", 'tabpanel');
            formWrapperForRolePanel.setAttribute("aria-labelledby", 'HFS_TabNavItem' + this.appContext);
          }
        }.bind(this));
        if (!hasActiveItem && tabNavList[0]) {
          tabNavList[0].setAttribute("tabindex", '0');
          formWrapperForRolePanel.removeAttribute("tabindex");
          formWrapperForRolePanel.removeAttribute("role");
          formWrapperForRolePanel.removeAttribute("aria-labelledby");
        }

        // Wenn der appContext kein Tab in der Navigation hat, wird ein dummy Tab erzeugt.
        if (_hasMainTab(this.appContext) || !Hafas.Config.UI.showAdditionalContextInTabMenu) {
          Hafas.ps.pub('/GUI/hideMenuItemInTabBar', []);
        }
        else {
          Hafas.ps.pub('/GUI/showMenuItemInTabBar', [this.appContext]);
        }

      }

      // TariffWizard muss (in layout-small) die gesamte Seite einnehmen
      var pageContent = Hafas('#HFS_PageContent');
      if (data.context === 'TariffWizard') {
        pageContent.classList.add('lyr_fullPage');
      } else {
        pageContent.classList.remove('lyr_fullPage');
      }

      if (data.method == null)
        return;

      // Render tabNavigationHeading before index method is called, that way the actionbar buttons can be modified in controller e.g. to init a options menu
      Hafas.ps.pub('/GUI/tabNavigationHeading/render', []);

      // if no method is set, use 'index'
      data.method = data.method || 'index';

      if (typeof this.Controller[data.context] == 'undefined') {
        data.context = 'TP'
      }

      // Call the initial method of the new context, e.g. index
      Hafas.bind(this.Controller[data.context][data.method], this)(data.params);

      // set Application-Context in Attribute data-resultfor for TP
      overview.setAttribute('data-resultfor', data.context);
      detail.setAttribute('data-resultfor', data.context);


      Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: data.context}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/GUI/common/setApplicationHeader', [{appcontext: data.context}]);

      if (Hafas.Config.initAnalysisMode) {
        Hafas.ps.pub('/analysis/init');
      }

      // Tracking
      // Hier muss für das tracking wieder einer Unterscheidung nach AppContext gemacht werden.
      // data.trigger kommt aus den menübuttons und ist somit der Indikator für das Tracking
      if (typeof data !== 'undefined' && typeof data.trigger != 'undefined' && typeof data.context !== 'undefined') {
        switch (data.context) {
          case 'TP':
            Hafas.ps.pub('/tracking/event/menu-journey-planner', [{typ: 'event', key: 'menu-journey-planner'}]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'tripplanner'}
            }]);
            break;
          case 'SQ':
            Hafas.ps.pub('/tracking/event/menu-stationboard-planner', [{
              typ: 'event',
              key: 'menu-stationboard-planner'
            }]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'stationboard'}
            }]);
            break;
          case 'Imprint':
            Hafas.ps.pub('/tracking/event/imprint', [{typ: 'event', key: 'imprint'}]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'info'}
            }]);
            break;
        }
      }

      if (Hafas.Modules.IFrameApi) {
        Hafas.Modules.IFrameApi.sendSwitchContext(data.context);
      }

      Hafas.ps.pub('/app/switchContext/done', []);
    },
    openURL: function(options){
       if(typeof options == 'undefined' || typeof options.url == 'undefined'){
         console.warn("openURL: check parameters, invalid or incomplete");
         return;
       }
       var target = '_blank';
       if(typeof options.target != 'undefined'){
         target = options.target;
       }
       window.open(options.url,target);
    },
    switchLanguage: function (data) {
      if (data.ev) data.ev.preventDefault();

      // change hciLanguage in Hafas.Config
      var availableLanguages = Hafas.Config.languages;
      var i = 0,
        iLen = availableLanguages.length,
        currentLangObject = null;
      for (i; i < iLen; i++) {
        if (data.lang === availableLanguages[i].lang) {
          currentLangObject = availableLanguages[i];
        }
      }

      // language Storage läuft nach einem Tag aus
      currentLangObject.expires = new Date().getTime() + 1000 * 60 * 60 * 24;

      try {
        localStorage.setItem(Hafas.Config.Storage.id+ 'lang', JSON.stringify(currentLangObject));
      } catch (e) {
        Hafas.logger.warn(
          Hafas.logger.ERROR_TYPES.STORAGE,
          "controller.switchLanguage",
          "Fehler: localStorage konnte nicht beschrieben werden.",
          e
        );
      }

      // Get SubPath, wenn im Mandanten /Whitelabelkontext
      var _customerPath = '';
      if (typeof Hafas.Config.isCustomer != 'undefined' && Hafas.Config.isCustomer === true) {
        _customerPath = '&L=' + Hafas.Util.getUrlParams('L') + '&';
      }


      Hafas.Config.defaultLang = currentLangObject.lang;
      Hafas.Config.HCI.hciLang = currentLangObject.hciLang;

      var baseURL = window.location.origin;
      var path = window.location.pathname;
      var search = '?language=' + Hafas.Config.defaultLang + _customerPath;
      var hash = window.location.hash;

      window.location.href = baseURL + path + search + hash;
    },
    triggerLoadingImage: function (trigger) {
      this.trigger = trigger;
      this.triggerLoadingImage = new Image();
      this.triggerLoadingImage.src = Hafas.Config.imagePath + Hafas.Config.loadingImage;
      this.triggerLoadingImage.width = '14px';
      this.triggerLoadingImage.height = '14px';
      this.trigger.setAttribute('disabled', 'disabled');
      this.trigger.appendChild(this.triggerLoadingImage);
    },
    /**
     * Initialize automatic reloading of the WebApp according to config.
     * @param {string} startUrl - The URL to restore when reloading
     */
    initReload: function (startUrl) {
      /**
       * Reload the initial state of the WebApp.
       */
      function reload () {
        window.location.assign(startUrl);
        // window.location.assign() will not cause a reload if URLs are the same or only differ in hash, so call reload()
        window.location.reload();
      }

      if (Hafas.Config.customConfig.AutoReload.autoReloadType === 'time') {
        // Reload the WebApp at a specific time every day

        var now = new Date();

        // Get reload time from config
        var timeArray = Hafas.Config.customConfig.AutoReload.reloadTime.split(':');
        var hours = parseInt(timeArray[0]);
        var minutes = parseInt(timeArray[1]);

        // Create reload time date object
        var reloadTime = new Date();
        reloadTime.setHours(hours);
        reloadTime.setMinutes(minutes);
        reloadTime.setSeconds(0);
        reloadTime.setMilliseconds(0);

        // Change date to tomorrow if reload time is in the past
        if (reloadTime < now) {
          reloadTime.setDate(reloadTime.getDate() + 1);
        }

        // Set timeout for the difference between the reload time and now, then reload
        setTimeout(function () {
          reload();
        }, reloadTime - now);

      } else if (Hafas.Config.customConfig.AutoReload.autoReloadType === 'interval') {
        // Reload the WebApp after a specific number of minutes of inactivity

        var reloadInterval = Hafas.Config.customConfig.AutoReload.reloadInterval;
        var reloadTimeout;

        /**
         * Clear and reset the timeout for reloading the WebApp.
         */
        function resetTimeout () {
          clearTimeout(reloadTimeout);
          reloadTimeout = setTimeout(reload, reloadInterval * 60 * 1000);
        }

        // Reset the timeout when a user interacts with the WebApp
        addEventListener('mousemove', resetTimeout);
        addEventListener('mousedown', resetTimeout);
        addEventListener('touchstart', resetTimeout);
        addEventListener('touchmove', resetTimeout);
        addEventListener('click', resetTimeout);
        addEventListener('keydown', resetTimeout);
        addEventListener('scroll', resetTimeout, true);

        resetTimeout();
      }
    },
    events: {
      renderDone: function (params) {
        // call announcements (if not explicitly surpressed)
        if(params === undefined || (params.suppressAnnouncements === undefined || params.suppressAnnouncements == false)) {
          if (HafasWebapp.prototype.Controller.App.events.renderDoneFunction) {
            HafasWebapp.prototype.Controller.App.events.renderDoneFunction();
          } else {
            HafasWebapp.prototype.Controller.App.events.renderDoneFunction = Hafas.Util.debounce(function () {
              Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
            }, 600);
            HafasWebapp.prototype.Controller.App.events.renderDoneFunction();
          }
        }
      },
      closeResults: function (data) {
        if (typeof data.ev != 'undefined') {
          data.ev.preventDefault();
        }

        var keepOverviewScrollPos = false;

        if (data && data.resultSet === 'detail') {
          keepOverviewScrollPos = true;
        }

        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/all/hide', [{}]);


        Hafas.ps.pub('/GUI/results/overview/removeActive', [{arrayIdx: null}]);
        Hafas.ps.pub('/GUI/results/additional/hideAll');
        Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
      }
    },
    /**
     * send information of defined stationboard page statuses to the Iframe API
     *
     * @method sendMetaInformation
     * @param {string} context - origin context of the meta information
     * @param {string} action - defined action to be sent over iframe API
     * @param {object} [data] - any object to be passed to the iframe API that can be used
     */
    sendMetaInformation: function(context, action, data){
      // Transfer information about the station
      if (Hafas.Modules.IFrameApi && Hafas.Config.Switches.useMetaDataApi) {
        // Prepare metadata object to be sent over the iframe API
        var metadata = {
          context: context,
          action: action
        };
        // Only set data if available
        if(data){
          metadata.data = data;
        }
        Hafas.Modules.IFrameApi.sendMetaData(metadata);
      }
    },
  },
  /**
   * @class this.Controller.Common
   */
  Common: {
    productSelection: function (current, context) {
      var selection = {};
      Hafas.Config.productClasses.forEach(function (obj, val) {
        // add grayscale image path for product selection /mroe
        var inactiveImgPath = obj.img.substr(0, (obj.img.length - 4));
        inactiveImgPath = inactiveImgPath.replace(/\/svg\//g, '\/svg/grayscale\/');
        obj.name = (obj.name.match(/common\.products/)) ? Hafas.Modules.i18n.get(obj.name) : obj.name;
        obj.img_inactive = inactiveImgPath + '_gray.svg';
        selection[obj.bit] = obj;
        selection[obj.bit].context = context;
        if ((typeof current != "undefined") && ((parseInt(obj.bit) & parseInt(current)) == (parseInt(obj.bit)))) {
          selection[obj.bit].checked = true;
        } else {
          selection[obj.bit].checked = "";
        }
      });
      return selection;
    },
    // INFO: Die Funktion wird nicht mehr vom Suggest verwendet.
    getActualPosition: function (trigger, ev, callback, param = null) {
      var target = 'From';

      if((typeof param.source != 'undefined' && param.source == 'jumpin') && typeof param.target != 'undefined'){
        target = 'To';
      }

      if (typeof ev != 'undefined' && typeof ev.preventDefault == 'function') {
        ev.preventDefault();
      }

      // Declarations
      var _me = this,
        _ctx = _me.appContext;

      var _inputMap = {
        TP: target,
        Map: 'MapLocation',
        SQ: 'Station',
        Reachability: 'ReachabilityLocation'
      };

      // Die Targetid muss anders ermittelt werden. Die Übergabe aus dem PubSub kann nicht mehr genutzt werden,
      // da der ActionLink ein allgemeingültiges Snippet ist und nicht mehr in den {context}.index-Dateien verankert ist
      Hafas.Util.geo.getActualPosition(Hafas.bind(function (position) {

        var $icon = Hafas('#HFS_GetActualPosition', false);
        if (position.error) {
          if ($icon) {
            $icon.setAttribute('disabled', 'disabled');
            $icon.setAttribute('aria-hidden', true);
            $icon.addClassName('hfs_currentPositionDisabled');
          }
          console.warn(position.error.state, position.error.msg);
          return;
        }
        else {
          if ($icon) {
            $icon.removeAttribute('disabled');
            $icon.removeAttribute('aria-hidden', true);
            $icon.removeClassName('hfs_currentPositionDisabled');
          }
        }
        Hafas.Util.geo.reverseLookup(position.hafasCCoord, function (locObj) {
          if (Array.isArray(locObj) && locObj.length > 0) {
            Hafas.ps.pub('/common/currentPositionActivated/' + _inputMap[_ctx], [locObj[0], _inputMap[_ctx]]);

            // Tracking current-position
            if (Hafas.getWebAppContext() === 'TP') {
              Hafas.ps.pub('/tracking/event/journey-planner-current-position', [{
                typ: 'event',
                key: 'journey-planner-current-position'
              }]);
              Hafas.ps.pub('/tracking/event/tripplanner-currentposition-pressed', [{
                typ: 'event',
                key: 'tripplanner-currentposition-pressed'
              }]);
            }
            else {
              Hafas.ps.pub('/tracking/event/locationsearch-currentposition-selected', [{
                typ: 'event',
                key: 'locationsearch-currentposition-selected'
              }]);
            }
            if (typeof callback === "function") callback(position);
          }
        }, null, {zoomDependent: false});
      }, this), true);
    },
    /* HCI Client Position setzen */
    setHCIClientPositionInfo: function(position){
      if(position !== undefined && position.error === undefined){
        Hafas.Config.HCI.hciClient.pos = { x: position.hafasCCoord.getLon(), y: position.hafasCCoord.getLat() };
        if(position.accuracy !== undefined){
          Hafas.Config.HCI.hciClient.pos.acc = position.accuracy;
        }
      }else{
        Hafas.bind(this.Controller.Common.clearHCIClientPositionInfo,this)();
      }
    },
    /* HCI Client Positions Info wird im Fehlerfall wieder entfernt */
    clearHCIClientPositionInfo: function(){
      // Im Fehlerfall (Location kann nicht mehr ermitteln) die Position wieder aus der hciClient Config entfernen
      delete Hafas.Config.HCI.hciClient.pos;
    },
    openLibTariff: function(extContObjKeeperRef,bkgDataRef){
      var externalContent = Hafas.Modules.Render.objectKeeper.get(extContObjKeeperRef);
      var bkgData = Hafas.Modules.Render.objectKeeper.get(bkgDataRef);
      var bkgDataString = JSON.stringify(bkgData);
      var decodedContent = Hafas.Util.b64DecodeUnicode(externalContent.content.content);
      if(typeof WebViewTicketing !== "undefined") {
        WebViewTicketing.showTicketProductScreen(bkgDataString, externalContent.content.content, "product");
      }else{
        console.warn("WebViewTicketing not available.");
        console.log("WebViewTicketing.showTicketProductScreen");
        console.log("bkgData",bkgDataString);
        console.log(externalContent.content.content);
      }
    },
    openExternalLink: function (url,options) {
      var urlWithEncodedParameters = Hafas.Util.encodeURLParameters(url);
      if (options == undefined || options.urlMode == undefined || options.urlMode == 'NEW_WINDOW') {
        window.open(urlWithEncodedParameters, "_blank");
      } else if(options.urlMode == "THIS_WINDOW") {
        window.open(urlWithEncodedParameters, "_self");
      } else if (options.urlMode == 'OVERLAY') {
        var html = '<iframe height="600" frameborder="0" src="' + urlWithEncodedParameters + '" width="100%" height="100%"></iframe>';
        if (options.htmlContent) {
          html = Hafas.Util.b64DecodeUnicode(options.htmlContent);
        }

        var overlayClass = 'hfs_extAppOverlay';
        if (typeof options.overlayClass != 'undefined') {
          overlayClass = options.overlayClass;
        }

        // Subview einfügen
        if (Hafas.Modules.History)
          Hafas.Modules.History.addSubView("/common/closeExternalLinkOverlay", "HafasOverlay", {});

        this.Controller.App.ExtAppOverlay = Hafas.Core.newType("HafasOverlay", {
          title: options.applicationName,
          app: this,
          outputHTML: html,
          cssClass: overlayClass,
          onClose: Hafas.bind(function () {
            Hafas.Modules.History.removeCurrentStep("HafasOverlay");
          }, this)
        });
      }
    },
    closeExternalLinkOverlay: function(){
       if(this.Controller.App.ExtAppOverlay){
          this.Controller.App.ExtAppOverlay.close();
       }
    },

    openInternalWebAppContext: function(params) {
      var jumpinInternalContext = true;
      var paramsResolved = Hafas.Modules.Render.objectKeeper.get(params.objKey);

      // EcoCheck - Aussprung
      if(paramsResolved.contentResolved !== undefined && paramsResolved.contentResolved == 'EcoCheck'){
        Hafas.ps.pub('/ecocheck/openEcoCheck', []);
        return;
      }
      Hafas.ps.sub('/app/contextLoaded/' + paramsResolved.context, function () {
        if(jumpinInternalContext) {
          Hafas.ps.pub('/common/subscriptions/done');
          Hafas.Modules.JumpIn.jumpInInternal(paramsResolved);
          jumpinInternalContext = false;
        }
      });
      var contextMapping = paramsResolved.context;
      switch(contextMapping) {
        case "TripSearch":
          contextMapping = "TP";
          break;
      }
      if(paramsResolved.context == "TripSearch") {
        contextMapping == "TP";
      }
      Hafas.ps.pub('/app/switchContext', [{'context': contextMapping, method: "index"}]);
    },
    /**
     * @class this.Controller.Common.Time
     */
    Time: {
      DatePicker: {
        consoleClr: 'background-color: #ea0; color: #000;',
        open: function (dateTimePickerInstance) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.show();
        },

        onShow: function (params) {
          var _dateTimePickerInstance = params.picker;
          //Hafas("#HFS_TabNavigation").style.zIndex = 10001;
          if(Hafas.Config.Styling.theme != 'formbased') {
            Hafas("#HFS_PageContent").style.backgroundColor = "transparent";
          }
          if (this.layoutClass == "small" && _dateTimePickerInstance.config.showFullscreenInMobile) {
            Hafas("#HFS_TabNavigation").style.display = "none";
            Hafas("body").style.overflow = "hidden";
          }
        },

        onHide: function (params) {
          Hafas("#HFS_TabNavigation").style.display = "";
          //Hafas("#HFS_TabNavigation").style.zIndex = "";
          Hafas("#HFS_PageContent").style.backgroundColor = "";
          Hafas("body").style.overflow = "";
          Hafas.ps.pub('/app/events/resize');

        },

        confirm: function (params) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('%c+++ this.Controller.Common.Time.DatePicker.confirm(tdpinstance)', this.Controller.Common.Time.DatePicker.consoleClr);
          }
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.confirm();
          Hafas.ps.pub('/tracking/event/datetimepicker-changed', [{
            typ: 'event',
            key: 'datetimepicker-changed',
            data: {type: 'accepted'}
          }]);

        },
        cancel: function (params) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('%c+++ this.Controller.Common.Time.DatePicker.cancel(tdpinstance)', this.Controller.Common.Time.DatePicker.consoleClr);
          }
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.cancel();
          Hafas.ps.pub('/tracking/event/datetimepicker-changed', [{
            typ: 'event',
            key: 'datetimepicker-changed',
            data: {type: 'cancelled'}
          }]);
        },
        setData: function (params) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          if (params.time)
            _dateTimePickerInstance.setTime(params.time);
          if (params.date)
            _dateTimePickerInstance.setDate(params.date);
          if (params.hasOwnProperty('enquiry'))
            _dateTimePickerInstance.setEnquiry(params.enquiry);
          if (params.timeNow)
            _dateTimePickerInstance.setTimeNow(params.timeNow)
        },
        onChangeNativeInput: function (params) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.readNativeFields(params);
        }
      }
    }
  },
  /**
   * @class this.Controller.APIs
   */
  APIs: {
    /**
     * @class this.Controller.APIs.Geolocation
     */
    Geolocation: {
      check: function () {

        if (typeof Hafas.Config.Switches.checkGeoLocationOnInit != 'undefined' && Hafas.Config.Switches.checkGeoLocationOnInit !== true) {
          return;
        }


        if (typeof Hafas.Config.Switches.useGetGeoLocation != 'undefined' && Hafas.Config.Switches.useGetGeoLocation === true) {
          Hafas.Util.geo.supportsGeoLocation(function (hasSupport) {
            var $icon = Hafas('#HFS_GetActualPosition', false);
            if (!hasSupport && $icon) {
              console.log('getActualposition wird nicht unterstützt');
              $icon.setAttribute('disabled', 'disabled');
              $icon.setAttribute('aria-hidden', true);
              $icon.addClassName('hfs_currentPositionDisabled');
            }
          });
        }
        else if (typeof Hafas.Config.Switches.useGetGeoLocation != 'undefined' && Hafas.Config.Switches.useGetGeoLocation === false) {

          // Das Suggest verwendet ebenfalls die Geolocation.
          // Muss auf "false" gesetzt werden, wenn Geolocation global schon nicht verwendet
          // werden soll.
          // VORSICHT: Die config-Parameter können schönen beim Instanzieren anders gesetzt sein!
          //           Diese Überprüfung erfolgt dann im Suggest-Modul in Abhängigkeit mit den Daten
          //           aus dem Hafas.Config.HTML5.APIs-Objekt
          Hafas.Config.Suggest.useActualPosition = false;
          Hafas.Config.Suggest.useNearLocation = false;

          Hafas.Config.HTML5.APIs.Geolocation.CanIUse = false;
          Hafas.Config.HTML5.APIs.Geolocation.Status = 'Geolocation not configured';

          // Der Errorcode '99' ist ausgedacht!
          // Er dient für die entsprechende Template-Ausgabe als Flag
          Hafas.Config.HTML5.APIs.Geolocation.ErrorCode = 99;

          var $icon = Hafas('#HFS_GetActualPosition', false);
          if ($icon) {
            $icon.setAttribute('aria-hidden', true);
            $icon.hidden = true;
            $icon.addClassName('hidden');
          }
        }
      }
    }
  },
  Favorites: {},
  Forms: {
    reset: function (opts) {
      switch (opts.appContext) {
        case 'TP':
          if (opts.form === 'index') {
            var $from = this.Controller.TP.inpFrom.inp;
            var $to = this.Controller.TP.inpTo.inp;

            $from.value = '';
            $to.value = '';
            // Todo: reset Calendar and Time data
            // Todo: reset Options

            // Reinit für Calender
            Hafas.Core.init();
          }
          break;
      }
    }
  },
  /**
   * @class this.Controller.Exceptions
   */
  Exceptions: {
    TQ: {
      getRoute: function (err) {
        var _me = this;
        Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: '<h1>' + err.requestId + ': ' + err.requestMethod + ' | ' + err.err + '</h1><p>' + err.errTxt + '</p>',
          cssClass: 'hfs_overlayExample',
          onClose: function () {
            console.log('Overlay closed')
          },
          callback: function (html, err) {
            if (err) console.error(err);

          }
        });
      },
      drawHighlightedSection: function (err) {
        var _me = this;
        Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: '<h1>' + err.requestId + ': ' + err.requestMethod + ' | ' + err.err + '</h1><p>' + err.errTxt + '</p>',
          cssClass: 'hfs_overlayExample',
          onClose: function () {
            console.log('Overlay closed')
          },
          callback: function (html, err) {
            if (err) console.error(err);

          }
        });
      }
    }
  },
  Debug: {
    a11y: function () {
      if (this.webappWrap) {
        var dom = Hafas('#' + this.webappWrap);
        if (dom) {
          dom.classList.add('lyr_debugA11yTesting');
        }
      }
    }
  }
};
